import { useFormContext } from "react-hook-form";
import { useCountry } from "@/config/country-context";
import {
	type RefinanceForm,
	findDebtIssues,
	useDebtValidationMessages,
} from "./use-refinance-form";

/**
 * Saves the debt at an index, or marks every field that keeps it from being
 * saved. Returns whether it was saved.
 */
export const useSaveDebt = (customerAccountNumber?: string | null) => {
	const { getValues, setValue, setError, clearErrors } =
		useFormContext<RefinanceForm>();
	const messages = useDebtValidationMessages();
	const country = useCountry();

	return (index: number): boolean => {
		const name = `debts.${index}` as const;
		const issues = findDebtIssues(
			getValues(name),
			messages,
			country,
			customerAccountNumber
		);

		clearErrors(name);
		for (const { field, message } of issues) {
			setError(`${name}.${field}`, { type: "custom", message });
		}
		if (issues.length > 0) return false;

		setValue(`${name}.saved`, true, { shouldDirty: true });
		return true;
	};
};
